import {isServer} from 'ac-share'
import {IWindow} from '../domain/IWindow'
import {ComponentEnum, ComponentNameEnum} from '../componentsRegistry/Registry'

export function isMacintosh(): boolean {
  if (!isServer) {
    const userAgent = window.navigator.userAgent.toLowerCase()
    const macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i
    const windowsPlatforms = /(win32|win64|windows|wince)/i
    const iosPlatforms = /(iphone|ipad|ipod)/i
    let os = null

    if (macosPlatforms.test(userAgent)) {
      os = 'macos'
      return true
    } else if (iosPlatforms.test(userAgent)) {
      os = 'ios'
      return true
    } else if (windowsPlatforms.test(userAgent)) {
      os = 'windows'
      return false
    } else if (/android/.test(userAgent)) {
      os = 'android'
      return false
    } else if (!os && /linux/.test(userAgent)) {
      os = 'linux'
      return false
    }
    return false
  }
}

export function getTitleSplit(leftId: ComponentEnum, rightId: ComponentEnum): string {
  return `На одном экране: ${ComponentNameEnum[leftId]} и ${ComponentNameEnum[rightId]}`
}

export function getStructureByWindowStyle(windowStyle: number): {
  topLeftWindow?: IWindow
  bottomLeftWindow?: IWindow
  topRightWindow?: IWindow
  bottomRightWindow?: IWindow
} {
  let topLeftWindow
  let bottomLeftWindow
  let topRightWindow
  let bottomRightWindow

  if (windowStyle === 1) {
    topLeftWindow = {
      activeComponentId: ComponentEnum.description,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.description},
        second: undefined,
        third: undefined,
      },
    }
    bottomLeftWindow = {
      activeComponentId: ComponentEnum.schema,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.schema, innerActiveComponentId: ComponentEnum.schemaDiagram},
        second: undefined,
        third: undefined,
      },
    }
    topRightWindow = {
      activeComponentId: ComponentEnum.editor,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.editor},
        second: {
          componentId: ComponentEnum.solution,
          innerActiveComponentId: ComponentEnum.masterSolution,
        },
        third: undefined,
      },
    }
    bottomRightWindow = {
      activeComponentId: ComponentEnum.myResult,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.myResult},
        second: {componentId: ComponentEnum.masterResult},
        third: undefined,
      },
    }
  } else if (windowStyle === 2) {
    topLeftWindow = {
      activeComponentId: ComponentEnum.description,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.description},
        second: {
          componentId: ComponentEnum.schema,
          innerActiveComponentId: ComponentEnum.schemaDiagram,
        },
        third: undefined,
      },
    }
    bottomLeftWindow = {
      activeComponentId: ComponentEnum.masterResult,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.masterResult},
        second: {
          componentId: ComponentEnum.schema,
          innerActiveComponentId: ComponentEnum.schemaDiagram,
        },
        third: {componentId: ComponentEnum.theory},
      },
    }
    topRightWindow = {
      activeComponentId: ComponentEnum.editor,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.editor},
        second: {
          componentId: ComponentEnum.solution,
          innerActiveComponentId: ComponentEnum.masterSolution,
        },
        third: undefined,
      },
    }
    bottomRightWindow = {
      activeComponentId: ComponentEnum.myResult,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.myResult},
        second: undefined,
        third: undefined,
      },
    }
  } else {
    topLeftWindow = {
      activeComponentId: ComponentEnum.description,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.description},
        second: {
          componentId: ComponentEnum.schema,
          innerActiveComponentId: ComponentEnum.schemaDiagram,
        },
        third: undefined,
      },
    }
    bottomLeftWindow = {
      activeComponentId: ComponentEnum.masterResult,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.masterResult},
        second: undefined,
        third: undefined,
      },
    }
    topRightWindow = {
      activeComponentId: ComponentEnum.editor,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.editor},
        second: {
          componentId: ComponentEnum.solution,
          innerActiveComponentId: ComponentEnum.masterSolution,
        },
        third: undefined,
      },
    }
    bottomRightWindow = {
      activeComponentId: ComponentEnum.myResult,
      isCollapsed: false,
      tab: {
        first: {componentId: ComponentEnum.myResult},
        second: undefined,
        third: undefined,
      },
    }
  }

  return {
    topLeftWindow: {...topLeftWindow},
    bottomLeftWindow: {...bottomLeftWindow},
    topRightWindow: {...topRightWindow},
    bottomRightWindow: {...bottomRightWindow},
  }
}
